window.jQuery = window.$ = require('jquery'); // jquery3.3.1 from node_modules
require('bootstrap-sass'); // bootstrap3.4.1 from node_modules
require('bootstrap-select');
